import { render } from "./buildingBand.vue?vue&type=template&id=2b1a8429&scoped=true"
import script from "./buildingBand.vue?vue&type=script&lang=js"
export * from "./buildingBand.vue?vue&type=script&lang=js"

import "./buildingBand.vue?vue&type=style&index=0&id=2b1a8429&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1a8429"]])

export default __exports__